module.exports = __webpack_public_path__ + "img/scheme-1.de2539f8.png";